<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="列表URL" prop="listJson">
          <el-input v-model="dataForm.listJson" placeholder="列表URL"></el-input>
      </el-form-item>
          <el-form-item label="详情URL" prop="detailJson">
          <el-input v-model="dataForm.detailJson" placeholder="详情URL"></el-input>
      </el-form-item>
          <el-form-item label="采集源名字" prop="resName">
          <el-input v-model="dataForm.resName" placeholder="采集源名字"></el-input>
      </el-form-item>
          <el-form-item label="第一次采集状态" prop="type">
          <el-radio-group v-model="dataForm.type">
            <el-radio :label="0">未采集过全部</el-radio>
            <el-radio :label="1">采集全部中</el-radio>
            <el-radio :label="2">采集全部完毕</el-radio>
          </el-radio-group>
      </el-form-item>
          <el-form-item label="使用状态" prop="status">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="0">使用</el-radio>
            <el-radio :label="1">不使用</el-radio>
          </el-radio-group>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        listJson: '',
        detailJson: '',
        resName: '',
        type: '',
        status: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        listJson: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        detailJson: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        resName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/cmsres/cmsres/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/cmsres/cmsres/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
